export enum SpendingLimitCategory {
    DailyLimit = 'DailyLimit',
    MonthlyLimit = 'MonthlyLimit',
    DailyLimitEcommerce = 'DailyLimitEcommerce',
    MonthlyLimitEcommerce = 'MonthlyLimitEcommerce',
}
